import { PROJECT_VARIANTS } from '../../constants';
import * as sonarActions from '../../redux/sonar/sonarActions';
import * as consumerSonarActions from '../../redux/consumer/sonar/consumerSonarActions';

const sonarActionsMapping = {
  getData: {
    [PROJECT_VARIANTS.ADMIN]: sonarActions.getSonarData,
    [PROJECT_VARIANTS.CONSUMER]: consumerSonarActions.getConsumerSonarData,
  },
  getNavig8: {
    [PROJECT_VARIANTS.ADMIN]: sonarActions.getSonarNavig8,
    [PROJECT_VARIANTS.CONSUMER]: consumerSonarActions.getConsumerSonarNavig8,
  },
  reply: {
    [PROJECT_VARIANTS.ADMIN]: sonarActions.replySonarNavig8,
    [PROJECT_VARIANTS.CONSUMER]: consumerSonarActions.replyConsumerSonarNavig8,
  },
};

export default sonarActionsMapping;
